<template>
  <iframe
    :src="`https://se.servicestart.com/account/payment/ccd.do?ui=${userId}`"
    width="100%"
    style="border: 0; width: 100%; height: 600px; overflow: hidden;"
  />
</template>
<script>
export default {
  metaInfo() {
    return {
      title: this.$t('pages.payment.title'),
    };
  },
  computed: {
    userId() {
      return this.$route.params['userId'];
    },
  },
};
</script>
